import { schema } from 'normalizr'; // --------- GET DATA FOR PRODUCTS --------- //

export var product = new schema.Entity('products', {}, {
  idAttribute: function idAttribute(_ref) {
    var id = _ref.id;
    return parseInt(id, 10);
  },
  processStrategy: function processStrategy(_ref2) {
    var id = _ref2.id,
        vendorId = _ref2.vendorId,
        productId = _ref2.productId,
        productName = _ref2.productName,
        productSlug = _ref2.productSlug,
        accountClosingFee = _ref2.accountClosingFee,
        addAccountOpeningFee = _ref2.addAccountOpeningFee,
        additionalCurrencies = _ref2.additionalCurrencies,
        annualFee = _ref2.annualFee,
        clientBankAppAndroidLink = _ref2.clientBankAppAndroidLink,
        clientBankAppIosLink = _ref2.clientBankAppIosLink,
        clientBankName = _ref2.clientBankName,
        clientBankWebLink = _ref2.clientBankWebLink,
        currency = _ref2.currency,
        enrollmentCardAbsolute = _ref2.enrollmentCardAbsolute,
        enrollmentCardDescription = _ref2.enrollmentCardDescription,
        enrollmentCardMax = _ref2.enrollmentCardMax,
        enrollmentCardMin = _ref2.enrollmentCardMin,
        enrollmentCardPercent = _ref2.enrollmentCardPercent,
        enrollmentCashAbsolute = _ref2.enrollmentCashAbsolute,
        enrollmentCashDescription = _ref2.enrollmentCashDescription,
        enrollmentCashMax = _ref2.enrollmentCashMax,
        enrollmentCashMin = _ref2.enrollmentCashMin,
        enrollmentCashPercent = _ref2.enrollmentCashPercent,
        enrollmentCashlessAbsolute = _ref2.enrollmentCashlessAbsolute,
        enrollmentCashlessAvailable = _ref2.enrollmentCashlessAvailable,
        enrollmentCashlessDescription = _ref2.enrollmentCashlessDescription,
        enrollmentCashlessMax = _ref2.enrollmentCashlessMax,
        enrollmentCashlessMin = _ref2.enrollmentCashlessMin,
        enrollmentCashlessPercent = _ref2.enrollmentCashlessPercent,
        enrollmentInternetAcquiringAbsolute = _ref2.enrollmentInternetAcquiringAbsolute,
        enrollmentInternetAcquiringDescription = _ref2.enrollmentInternetAcquiringDescription,
        enrollmentInternetAcquiringMin = _ref2.enrollmentInternetAcquiringMin,
        enrollmentInternetAcquiringPercent = _ref2.enrollmentInternetAcquiringPercent,
        enrollmentTradeAcquiringAbsolute = _ref2.enrollmentTradeAcquiringAbsolute,
        enrollmentTradeAcquiringDescription = _ref2.enrollmentTradeAcquiringDescription,
        enrollmentTradeAcquiringMin = _ref2.enrollmentTradeAcquiringMin,
        enrollmentTradeAcquiringPercent = _ref2.enrollmentTradeAcquiringPercent,
        firstAccountOpeningFee = _ref2.firstAccountOpeningFee,
        foreignCurrencyBuyDescription = _ref2.foreignCurrencyBuyDescription,
        foreignCurrencyBuyMin = _ref2.foreignCurrencyBuyMin,
        foreignCurrencyBuyPercent = _ref2.foreignCurrencyBuyPercent,
        foreignCurrencyDescription = _ref2.foreignCurrencyDescription,
        foreignCurrencyExchangeAvailable = _ref2.foreignCurrencyExchangeAvailable,
        foreignCurrencyExchangeMin = _ref2.foreignCurrencyExchangeMin,
        foreignCurrencyExchangePercent = _ref2.foreignCurrencyExchangePercent,
        foreignCurrencySellDescription = _ref2.foreignCurrencySellDescription,
        foreignCurrencySellPercent = _ref2.foreignCurrencySellPercent,
        internetAcquiringAvailable = _ref2.internetAcquiringAvailable,
        monthlyFee = _ref2.monthlyFee,
        monthlyFeeDescription = _ref2.monthlyFeeDescription,
        paymentAbsolute = _ref2.paymentAbsolute,
        paymentAdditionalFee = _ref2.paymentAdditionalFee,
        paymentDescription = _ref2.paymentDescription,
        paymentInternalAbsolute = _ref2.paymentInternalAbsolute,
        paymentInternalDescription = _ref2.paymentInternalDescription,
        paymentInternalMin = _ref2.paymentInternalMin,
        paymentInternalPercent = _ref2.paymentInternalPercent,
        paymentMin = _ref2.paymentMin,
        paymentPercent = _ref2.paymentPercent,
        paymentSelfDescription = _ref2.paymentSelfDescription,
        paymentSelfMin = _ref2.paymentSelfMin,
        paymentSelfPercent = _ref2.paymentSelfPercent,
        proceedsEnrollmentCashboxAbsolute = _ref2.proceedsEnrollmentCashboxAbsolute,
        proceedsEnrollmentCashboxAvailable = _ref2.proceedsEnrollmentCashboxAvailable,
        proceedsEnrollmentCashboxDescription = _ref2.proceedsEnrollmentCashboxDescription,
        proceedsEnrollmentCashboxMin = _ref2.proceedsEnrollmentCashboxMin,
        proceedsEnrollmentCashboxPercent = _ref2.proceedsEnrollmentCashboxPercent,
        proceedsEnrollmentTerminalAbsolute = _ref2.proceedsEnrollmentTerminalAbsolute,
        proceedsEnrollmentTerminalAvailable = _ref2.proceedsEnrollmentTerminalAvailable,
        proceedsEnrollmentTerminalDescription = _ref2.proceedsEnrollmentTerminalDescription,
        proceedsEnrollmentTerminalMin = _ref2.proceedsEnrollmentTerminalMin,
        proceedsEnrollmentTerminalPercent = _ref2.proceedsEnrollmentTerminalPercent,
        productAccountOpeningDescription = _ref2.productAccountOpeningDescription,
        productAccountOpeningRemote = _ref2.productAccountOpeningRemote,
        productAccountStatementDescription = _ref2.productAccountStatementDescription,
        productBenefits = _ref2.productBenefits,
        productBusinessCreditsDescription = _ref2.productBusinessCreditsDescription,
        productBusinessDepositsDescription = _ref2.productBusinessDepositsDescription,
        productCardCreditLinkName = _ref2.productCardCreditLinkName,
        productCardCreditLinkUrl = _ref2.productCardCreditLinkUrl,
        productCardDebitLinkName = _ref2.productCardDebitLinkName,
        productCardDebitLinkUrl = _ref2.productCardDebitLinkUrl,
        productCashCollectionDescription = _ref2.productCashCollectionDescription,
        productClientActivityType = _ref2.productClientActivityType,
        productClientType = _ref2.productClientType,
        productConciergeService = _ref2.productConciergeService,
        productConciergeServiceDescription = _ref2.productConciergeServiceDescription,
        productSalaryProjectDescription = _ref2.productSalaryProjectDescription,
        selfPaymentSelfAbsolute = _ref2.selfPaymentSelfAbsolute,
        swiftAbsolute = _ref2.swiftAbsolute,
        swiftAvailable = _ref2.swiftAvailable,
        swiftCurrency = _ref2.swiftCurrency,
        swiftDescription = _ref2.swiftDescription,
        swiftMax = _ref2.swiftMax,
        swiftMin = _ref2.swiftMin,
        swiftPercent = _ref2.swiftPercent,
        tariffBankDescription = _ref2.tariffBankDescription,
        trackingUrl = _ref2.trackingUrl,
        tradeAcquiringAvailable = _ref2.tradeAcquiringAvailable,
        withdrawalAtmAbsolute = _ref2.withdrawalAtmAbsolute,
        withdrawalAtmAvailable = _ref2.withdrawalAtmAvailable,
        withdrawalAtmDescription = _ref2.withdrawalAtmDescription,
        withdrawalAtmMin = _ref2.withdrawalAtmMin,
        withdrawalAtmPercent = _ref2.withdrawalAtmPercent,
        withdrawalCashboxAbsolute = _ref2.withdrawalCashboxAbsolute,
        withdrawalCashboxDescription = _ref2.withdrawalCashboxDescription,
        withdrawalCashboxMin = _ref2.withdrawalCashboxMin,
        withdrawalCashboxPercent = _ref2.withdrawalCashboxPercent,
        withdrawalForeignAtmAbsolute = _ref2.withdrawalForeignAtmAbsolute,
        withdrawalForeignAtmAvailable = _ref2.withdrawalForeignAtmAvailable,
        withdrawalForeignAtmDescription = _ref2.withdrawalForeignAtmDescription,
        withdrawalForeignAtmMin = _ref2.withdrawalForeignAtmMin,
        withdrawalForeignAtmPercent = _ref2.withdrawalForeignAtmPercent,
        withdrawalForeignCashboxAbsolute = _ref2.withdrawalForeignCashboxAbsolute,
        withdrawalForeignCashboxAvailable = _ref2.withdrawalForeignCashboxAvailable,
        withdrawalForeignCashboxDescription = _ref2.withdrawalForeignCashboxDescription,
        withdrawalForeignCashboxMin = _ref2.withdrawalForeignCashboxMin,
        withdrawalForeignCashboxPercent = _ref2.withdrawalForeignCashboxPercent,
        productAdvantages = _ref2.productAdvantages;
    return {
      id: parseInt(id, 10) || 0,
      vendorId: parseInt(vendorId, 10) || 0,
      productId: productId,
      productName: productName,
      productSlug: productSlug,
      advantages: productAdvantages,
      accountClosingFee: accountClosingFee,
      addAccountOpeningFee: addAccountOpeningFee,
      additionalCurrencies: Array.isArray(additionalCurrencies) ? additionalCurrencies : [],
      annualFee: annualFee,
      clientBankAppAndroidLink: clientBankAppAndroidLink,
      clientBankAppIosLink: clientBankAppIosLink,
      clientBankName: clientBankName,
      clientBankWebLink: clientBankWebLink,
      currency: currency,
      enrollmentCardAbsolute: enrollmentCardAbsolute,
      enrollmentCardDescription: enrollmentCardDescription,
      enrollmentCardMax: enrollmentCardMax,
      enrollmentCardMin: enrollmentCardMin,
      enrollmentCardPercent: enrollmentCardPercent,
      enrollmentCashAbsolute: enrollmentCashAbsolute,
      enrollmentCashDescription: enrollmentCashDescription,
      enrollmentCashMax: enrollmentCashMax,
      enrollmentCashMin: enrollmentCashMin,
      enrollmentCashPercent: enrollmentCashPercent,
      enrollmentCashlessAbsolute: enrollmentCashlessAbsolute,
      enrollmentCashlessAvailable: Boolean(enrollmentCashlessAvailable),
      enrollmentCashlessDescription: enrollmentCashlessDescription,
      enrollmentCashlessMax: enrollmentCashlessMax,
      enrollmentCashlessMin: enrollmentCashlessMin,
      enrollmentCashlessPercent: enrollmentCashlessPercent,
      enrollmentInternetAcquiringAbsolute: enrollmentInternetAcquiringAbsolute,
      enrollmentInternetAcquiringDescription: enrollmentInternetAcquiringDescription,
      enrollmentInternetAcquiringMin: enrollmentInternetAcquiringMin,
      enrollmentInternetAcquiringPercent: enrollmentInternetAcquiringPercent,
      enrollmentTradeAcquiringAbsolute: enrollmentTradeAcquiringAbsolute,
      enrollmentTradeAcquiringDescription: enrollmentTradeAcquiringDescription,
      enrollmentTradeAcquiringMin: enrollmentTradeAcquiringMin,
      enrollmentTradeAcquiringPercent: enrollmentTradeAcquiringPercent,
      firstAccountOpeningFee: firstAccountOpeningFee,
      foreignCurrencyBuyDescription: foreignCurrencyBuyDescription,
      foreignCurrencyBuyMin: foreignCurrencyBuyMin,
      foreignCurrencyBuyPercent: foreignCurrencyBuyPercent,
      foreignCurrencyDescription: foreignCurrencyDescription,
      foreignCurrencyExchangeAvailable: Boolean(foreignCurrencyExchangeAvailable),
      foreignCurrencyExchangeMin: foreignCurrencyExchangeMin,
      foreignCurrencyExchangePercent: foreignCurrencyExchangePercent,
      foreignCurrencySellDescription: foreignCurrencySellDescription,
      foreignCurrencySellPercent: foreignCurrencySellPercent,
      internetAcquiringAvailable: Boolean(internetAcquiringAvailable),
      monthlyFee: monthlyFee,
      monthlyFeeDescription: monthlyFeeDescription,
      paymentAbsolute: paymentAbsolute,
      paymentAdditionalFee: paymentAdditionalFee,
      paymentDescription: paymentDescription,
      paymentInternalAbsolute: paymentInternalAbsolute,
      paymentInternalDescription: paymentInternalDescription,
      paymentInternalMin: paymentInternalMin,
      paymentInternalPercent: paymentInternalPercent,
      paymentMin: paymentMin,
      paymentPercent: paymentPercent,
      paymentSelfDescription: paymentSelfDescription,
      paymentSelfMin: paymentSelfMin,
      paymentSelfPercent: paymentSelfPercent,
      proceedsEnrollmentCashboxAbsolute: proceedsEnrollmentCashboxAbsolute,
      proceedsEnrollmentCashboxAvailable: Boolean(proceedsEnrollmentCashboxAvailable),
      proceedsEnrollmentCashboxDescription: proceedsEnrollmentCashboxDescription,
      proceedsEnrollmentCashboxMin: proceedsEnrollmentCashboxMin,
      proceedsEnrollmentCashboxPercent: proceedsEnrollmentCashboxPercent,
      proceedsEnrollmentTerminalAbsolute: proceedsEnrollmentTerminalAbsolute,
      proceedsEnrollmentTerminalAvailable: Boolean(proceedsEnrollmentTerminalAvailable),
      proceedsEnrollmentTerminalDescription: proceedsEnrollmentTerminalDescription,
      proceedsEnrollmentTerminalMin: proceedsEnrollmentTerminalMin,
      proceedsEnrollmentTerminalPercent: proceedsEnrollmentTerminalPercent,
      productAccountOpeningDescription: productAccountOpeningDescription,
      productAccountOpeningRemote: productAccountOpeningRemote,
      productAccountStatementDescription: productAccountStatementDescription,
      productBenefits: productBenefits,
      productBusinessCreditsDescription: productBusinessCreditsDescription,
      productBusinessDepositsDescription: productBusinessDepositsDescription,
      productCardCreditLinkName: productCardCreditLinkName,
      productCardCreditLinkUrl: productCardCreditLinkUrl,
      productCardDebitLinkName: productCardDebitLinkName,
      productCardDebitLinkUrl: productCardDebitLinkUrl,
      productCashCollectionDescription: productCashCollectionDescription,
      productClientActivityType: Array.isArray(productClientActivityType) ? productClientActivityType : [],
      productClientType: Array.isArray(productClientType) ? productClientType : [],
      productConciergeService: productConciergeService,
      productConciergeServiceDescription: productConciergeServiceDescription,
      productSalaryProjectDescription: productSalaryProjectDescription,
      selfPaymentSelfAbsolute: selfPaymentSelfAbsolute,
      swiftAbsolute: swiftAbsolute,
      swiftAvailable: Boolean(swiftAvailable),
      swiftCurrency: Array.isArray(swiftCurrency) ? swiftCurrency : [],
      swiftDescription: swiftDescription,
      swiftMax: swiftMax,
      swiftMin: swiftMin,
      swiftPercent: swiftPercent,
      tariffBankDescription: tariffBankDescription,
      trackingUrl: trackingUrl,
      tradeAcquiringAvailable: Boolean(tradeAcquiringAvailable),
      withdrawalAtmAbsolute: withdrawalAtmAbsolute,
      withdrawalAtmAvailable: Boolean(withdrawalAtmAvailable),
      withdrawalAtmDescription: withdrawalAtmDescription,
      withdrawalAtmMin: withdrawalAtmMin,
      withdrawalAtmPercent: withdrawalAtmPercent,
      withdrawalCashboxAbsolute: withdrawalCashboxAbsolute,
      withdrawalCashboxDescription: withdrawalCashboxDescription,
      withdrawalCashboxMin: withdrawalCashboxMin,
      withdrawalCashboxPercent: withdrawalCashboxPercent,
      withdrawalForeignAtmAbsolute: withdrawalForeignAtmAbsolute,
      withdrawalForeignAtmAvailable: Boolean(withdrawalForeignAtmAvailable),
      withdrawalForeignAtmDescription: withdrawalForeignAtmDescription,
      withdrawalForeignAtmMin: withdrawalForeignAtmMin,
      withdrawalForeignAtmPercent: withdrawalForeignAtmPercent,
      withdrawalForeignCashboxAbsolute: withdrawalForeignCashboxAbsolute,
      withdrawalForeignCashboxAvailable: Boolean(withdrawalForeignCashboxAvailable),
      withdrawalForeignCashboxDescription: withdrawalForeignCashboxDescription,
      withdrawalForeignCashboxMin: withdrawalForeignCashboxMin,
      withdrawalForeignCashboxPercent: withdrawalForeignCashboxPercent
    };
  }
});
export var products = [product];